﻿class AutoSubmit extends HTMLElement {
  connectedCallback() {
    let disabled = this.hasAttribute('disabled');
    let scrollTop = this.hasAttribute('scroll-top');

    if (!disabled) {
      this.addEventListener('change', (e) => {
        (e.target as HTMLInputElement).form.requestSubmit();
        if (scrollTop) {
          window.scrollTo({ top: 0 });
        }
      });
    }
  }
}

customElements.define('auto-submit', AutoSubmit);
